import HttpService from '../../../system/rest/rest.service';

/**
 * @param {String} id
 * @return {Promise<Any>}
 */
export async function removeFile(id) {
    return HttpService.delete('/v1/files/' + id);
}

/**
 * @param {String} mediaId
 * @return {Promise<Any>}
 */
export async function loadFiles(mediaId) {
    return HttpService.get('/v1/files', {mediaId});
}

/**
 * @param {Object} data
 * @return {Promise<Any>}
 */
export async function updateFile(data) {
    const {id} = data;
    delete data.id;
    return HttpService.put('/v1/files/' + id, data);
}

/**
 * @param {String} id
 * @return {Promise<Any>}
 */
export async function removeImage(id) {
    return HttpService.delete('/v1/images/' + id);
}

/**
 * @param {String} mediaId
 * @return {Promise<Any>}
 */
export async function loadImages(mediaId) {
    return HttpService.get('/v1/images', {mediaId});
}

/**
 * @param {Object} data
 * @return {Promise<Any>}
 */
export async function updateImage(data) {
    const {id} = data;
    delete data.id;
    return HttpService.put('/v1/images/' + id, data);
}

